import Edit from "@mui/icons-material/Edit";
import { IconButton, Tooltip } from "@mui/material";

import type { UUID } from "../../../../utils/uuid";
import type { FC } from "react";

export const EditAction: FC<{
  id: UUID | null;
  title: string | null;
  follow_up_id?: UUID | null;
}> = ({ id, title, follow_up_id }) => (
  <Tooltip title={`Edit Communication: ${title}`}>
    <IconButton
      data-analytics-id="moment-card-edit"
      href={follow_up_id ? `/follow-up/${follow_up_id}` : `/moments/${id || ""}`}
    >
      <Edit fontSize="small" sx={{ marginLeft: 0 }} data-testid="moment-edit-icon" />
    </IconButton>
  </Tooltip>
);
